import React from 'react';
import { generatePath, Link } from 'react-router-dom';
import Chip from '@mui/material/Chip';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import ReportDataType from '@/constants/api/ReportDataType';
import ConstituentSearchFilterField from '@/constants/ConstituentSearchFilterField';
import DateType from '@/constants/DateType';
import FilterOperator from '@/constants/forms/FilterOperator';
import LabelResourceTypes from '@/constants/labels/LabelResourceTypes';
import AuthRoutes from '@/constants/routing/AuthRoutes';
import {
  START_OF_1900_API_FORMAT,
  TODAY_API_FORMAT,
} from '@/lib/constants/dateConstants';
import joinNonEmptyParams from '@/utils/joinNonEmptyParams';

function LabelChips({ className, labels, resource, size }) {
  const authRoute =
    resource === LabelResourceTypes.DON
      ? AuthRoutes.REPORTS
      : AuthRoutes.CONSTITUENTS;

  const getParams = React.useCallback(
    (labelId) => {
      if (resource === LabelResourceTypes.DON) {
        return {
          dateType: DateType.CUSTOM_DATES,
          endDate: TODAY_API_FORMAT,
          labelIds: labelId,
          labelResourceType: LabelResourceTypes.DON,
          reportType: ReportDataType.DONATIONS,
          startDate: START_OF_1900_API_FORMAT,
        };
      }
      return {
        filters: JSON.stringify([
          {
            field: ConstituentSearchFilterField.CONSTITUENT_LABEL_IDS,
            operator: FilterOperator.ANY,
            value: [labelId],
          },
        ]),
      };
    },
    [resource],
  );

  return labels.length ? (
    <div className={classNames(className, 'flex flex-wrap gap-1')}>
      {labels.map(({ labelId, labelName }) => (
        <Link
          key={labelId}
          className="truncate"
          to={{
            pathname: generatePath(authRoute),
            search: joinNonEmptyParams(getParams(labelId)),
          }}
        >
          <Chip
            key={labelName}
            label={labelName}
            size={size}
            color="primary"
            className="cursor-pointer bg-secondaryButton-main text-secondary-dark type-body3 hover:bg-secondaryButton-dark"
          />
        </Link>
      ))}
    </div>
  ) : null;
}

LabelChips.propTypes = {
  className: PropTypes.string,
  labels: PropTypes.arrayOf(
    PropTypes.shape({
      labelId: PropTypes.string,
      labelName: PropTypes.string,
    }),
  ),
  resource: PropTypes.oneOf(Object.values(LabelResourceTypes)),
  size: PropTypes.oneOf(['medium', 'small']),
};

LabelChips.defaultProps = {
  className: '',
  labels: [],
  resource: LabelResourceTypes.CNX,
  size: 'medium',
};

export default LabelChips;
